import React,{ useState, useEffect } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import Header from "./Header";
import { ROUTE_BASE_URL } from "../../api/common";
import Footer from "./Footer";
import { FaCheckCircle, FaDownload } from "react-icons/fa";
import { convertDBDate } from './common';
import {
  GetMemberPaymentInfo
} from "../../components/UserMembershipApplication/Api/services/Webservices";
import PaymentReceipt from "../Template/payment";
import { decryptSlug } from "../../util/encryption"; 
const PaymentSuccess = () => {
  const { slug } = useParams();
  const decryptedId = decryptSlug(slug);
  const useQuery = () => {return new URLSearchParams(useLocation().search)};      
  const query = useQuery();
  const [applicationId, setApplicationId] = useState(parseInt(decryptSlug(query.get("id"))));  
  const [invoiceData, setInvoiceData] = useState(null);
  const [userData, setUserData] = useState({});
  const [userPaymentData, setUserPaymentData] = useState({});
  const [userApplicationData, setUserApplicationData] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPaymentReceipt, setShowPaymentReceipt] = useState(false);
  const handleClosePaymentReceipt = () => {
    setShowPaymentReceipt(false);
  };
  useEffect(() => {
    try {
      setLoading(true);
      GetMemberPaymentInfo({application_no: decryptedId})
      .then((res) => {
        console.log(res, "UserMemberData");
        setInvoiceData(res);
        if (res.status === true && res.data && res.data.length > 0) {
          const details = res.data[0];
          setUserData(details);
        }
        if (res.status === true && res.payment_status && res.payment_status.length > 0) {
          const details = res.payment_status[0];
          setUserPaymentData(details);
        }
        if (res.status === true && res.application_data && res.application_data.length > 0) {
          const details = res.application_data[0];
          setUserApplicationData(details);
        }
      })
      .catch((err) => {
        console.log(err);
      });}
      catch (error) {
        console.error("Error fetching member info:", error);
      }
      finally {
        setLoading(false);
      }
  }, []);
    return (
        <>
            <section className="user_div_total">
               <Header/>
                {/* <div className="container pt-50">
                    <div className="row">
                        <div className="col-md-12 card text-center success_page">
                            <div className="body">
                                <div className="success_head">
                                    <h2>APPLICATION SUBMITTED SUCCESSFULLY</h2>
                                    <p>Application id: <span>{decryptedId || "N/A"}</span></p>
                                </div>
                                <div className="   ">
                                    <p>You can use the above application id to track the status of your application.</p>
                                </div>
                                <div className="buttoon_center_dis pt-2 pb-2">
                                    <Link to={`${ROUTE_BASE_URL}/user-member-application-track`}>
                                    <button className="btn btn-primary btn-block width-auto" type="button">TRACK STATUS</button>
                                    </Link>
                                </div>
                                <div className="pt-2 pb-2">
                                    <p className="text-danger">Note: A link for membership fee will be sent to your registered
                                        email once your application is approved by Secretary General</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                {!loading && (
                <div className="application_div_page">
                  <div className="application-success">
                    <div className="success-icon">
                      <FaCheckCircle />
                    </div>
                    <h1>Application Submitted Successfully</h1>
                    <div className="summary-box">
                      <div className="summary-header">
                        <h2>Application Summary</h2>
                        <span className="reference">
                          Application id: <strong>{decryptedId}</strong>
                          {/* <i class="fa fa-copy" /> */}
                        </span>
                      </div>

                      <p className="greeting">
                        Dear <strong>Dr. {userData.first_name ? userData.first_name : ""}
                        {userData.middle_name ? " " + userData.middle_name : ""}
                        {userData.last_name ? " " + userData.last_name : ""}
                          </strong>,
                      </p>
                      <p>
                        We are pleased to confirm that we have received your AMASI membership application with payment receipt attached.
                      </p>
                      <p>
                        Our team will review your application and respond within 24 hours. You can check your application status using the track button below or directly on our website using your reference number.
                      </p>

                      <div className="info-box">
                        <div className="info-item">
                          <label>Membership Type</label>
                          <p><strong>{userApplicationData.application_name}</strong></p>
                        </div>
                        <div className="info-item">
                          <label>Submission Date</label>
                          <p><strong>{convertDBDate (userData.created_on)}</strong></p>
                        </div>
                      </div>
                     {[1, 2, 3, 4].includes(applicationId)&&
                     <div>
                      <div className="payment-box">
                        <h3>Payment Details</h3>
                        <div className="payment-row">
                          <span>Base Amount</span>
                          <strong>₹{userPaymentData.application_fee}</strong>
                        </div>
                       {
                        parseInt (userPaymentData.gstamount) > 0 &&
                          <div className="payment-row">
                            <span>GST ({userPaymentData.gst_value}%)</span>
                            <strong>₹{userPaymentData.gstamount}</strong>
                          </div>
                        }
                        {
                          parseInt (userPaymentData.application_process_fee) > 0 &&
                          <div className="payment-row">
                            <span>Processing Fee</span>
                            <strong>₹{userPaymentData.application_process_fee}</strong>
                          </div>
                        }
                        <div className="payment-row total">
                          <span>Total Amount</span>
                          <strong>
                            ₹
                            {parseInt (userPaymentData.application_fee) +
                              parseInt (userPaymentData.gstamount) + parseInt (userPaymentData.application_process_fee) } 
                          </strong>
                        </div>
                        <div className="receipt-row">
                          <span>Receipt sent to {userPaymentData.customerEmail}</span>
                          <button
                            onClick={() => setShowPaymentReceipt (true)}
                            className="download-btn"
                          >
                            <FaDownload /> Download Receipt
                          </button>
                        </div>
                      </div>

                      <div className="info-note">
                        <strong>Payment Receipt:</strong>
                        {' '}
                        A copy of your payment receipt has been emailed to
                        {' '}
                        <span>{userPaymentData.customerEmail}</span>
                        . If you don’t see it in your inbox, please check your spam or junk folder.
                      </div>

                      <div className="warning-note">
                        <strong>Important Note:</strong>
                        {' '}
                        Applications that do not fulfill the eligibility criteria will be rejected. Only the application fee will be refunded (GST refund is subject to policy).
                      </div>
                      </div>}

                      <div className="action-buttons login_details_popup ">
                        <Link to={`${ROUTE_BASE_URL}/user-member-application-track`}>
                          <button className="btn btn-primary ">TRACK STATUS</button>
                        </Link>
                        <a href={`https://www.amasi.org/`}>
                          <button className="btn btn-outline-default">Visit Website</button>
                        </a>
                      </div>
                    </div>
                  </div>
                  {showPaymentReceipt &&
                    <div
                      style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: 9999,
                        backgroundColor: '#000000ad',
                        padding: '20px',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                        overflow: 'auto',
                      }}
                    >
                      <button
                        onClick={() => handleClosePaymentReceipt ()}
                        className="search_toggle btn btn-danger search_tracking_div"
                      >
                        <i className="fa fa-times" />
                      </button>
                      <div
                        style={{
                          width: '100%',
                          height: '100%',
                          overflowY: 'auto',
                        }}
                      >
                        <PaymentReceipt invoiceData={invoiceData} />
                      </div>
                    </div>}
                </div>
                )}
                <Footer/>
            </section>
        </>
    );

}


export default PaymentSuccess
